import { TabularTypeSettings } from 'app/model/dataflow/dataset-settings/tabular-type-settings';
import { Metamodel } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { OracleTableDataset } from 'app/model/dataset/oracle-table.dataset';
import { DataFlowExpression } from 'app/model/dataflow/dataflowexpression';
import { IntegerDataFlowType } from 'worker/app-workers/shared/models/dataflow-datatype';

@Metamodel.model({
    name: adfModelTypeMap.oracle.dataflowSettings
})
export class OracleSettings extends TabularTypeSettings {
    public timeout: DataFlowExpression;

    public getDatasetType(): string {
        return Metamodel.modelFor(OracleTableDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.Oracle;
    }

    public getIconClass(): string {
        return 'i-100x100-Oracle';
    }

    public getSubFormat(): string {
        return undefined;
    }

    public initialize(subFormat: string): void {
        super.initialize(subFormat);
        this.timeout = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
    }
}
